<template>
  <div>
    <h1>Alap Adatok</h1>
    <div>
      <i class="bi bi-arrow-down"></i>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Szerződő <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="szerzodo-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider rules="int_required" v-slot="{errors}" class="col-sm-8">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input dark-border"
              id="maganszemely"
              name="maganszemely"
              :value="1"
              v-model="contractType"
            />
            <label for="maganszemely" class="form-check-label">Magánszemély</label>
          </div>
          <small id="jogiszemely-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="biztositas_targya"
          >Mire kíván biztosítást kötni? <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <div class="row">
            <input
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingatlan_ingosag'"
              v-if="contractFor == 1"
            />
            <input
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingatlan'"
              v-else-if="contractFor == 2"
            />
            <input
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingosag'"
              v-else-if="contractFor == 3"
            />
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 1"
                :class="{'btn-red': contractFor == 1, 'btn-outline-danger': contractFor !== 1}"
              >
                Ingatlan és ingóság
              </button>
            </div>
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 2"
                :class="{'btn-red': contractFor == 2, 'btn-outline-danger': contractFor !== 2}"
              >
                Csak ingatlan
              </button>
            </div>
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 3"
                :class="{'btn-red': contractFor == 3, 'btn-outline-danger': contractFor !== 3}"
              >
                Csak ingóság
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Milyen típusú a biztosítani kívánt ingatlan? <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="tipusa-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_lakas"
              :value="'tarsashaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_lakas">
              Társasházi lakás
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_csaladihaz"
              :value="'csaladihaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_csaladihaz">
              Családi ház
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_sorhaz"
              :value="'sorhaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_sorhaz">
              Sorház
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_ikerhaz"
              :value="'ikerhaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_ikerhaz">
              Ikerház
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >A biztosítani kívánt ingatlan állandóan lakott? <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="allandoan_lakott-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider :immediate="true" rules="required" class="col-sm-8" v-slot="{errors}">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="allando_lakott"
              id="allandoan_lakott_igen"
              :value="1"
              v-model="propertyInhabitated"
            />
            <label class="form-check-label" for="allandoan_lakott_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="allando_lakott"
              id="allandoan_lakott_nem"
              :value="0"
              v-model="propertyInhabitated"
            />
            <label class="form-check-label" for="allandoan_lakott_nem">
              Nem
            </label>
          </div>
          <small
            id="allandoan_lakott-error"
            class="text-danger input-alert"
            v-if="propertyInhabitated == 0"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Az ingatlan külterületen helyezkedik el? <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="kulterulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kulterulet"
              id="kulterulet_nem"
              :value="0"
              v-model="propertyOutskirts"
            />
            <label class="form-check-label" for="kulterulet_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kulterulet"
              id="kulterulet_igen"
              :value="1"
              v-model="propertyOutskirts"
            />
            <label class="form-check-label" for="kulterulet_igen">
              Igen
            </label>
          </div>
          <small id="kulterulet-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Folytatnak-e olyan vállalkozási tevékenységet az ingatlanban, ami nem szellemi
          munkavégzés? <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="fizikai-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider
          :immediate="true"
          rules="int_not_required"
          class="col-sm-8"
          v-slot="{errors}"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="fizikai"
              id="vallalkozas_nem"
              :value="0"
              v-model="propertyPhysicalJob"
            />
            <label class="form-check-label" for="vallalkozas_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="fizikai"
              id="vallalkozas_igen"
              :value="1"
              v-model="propertyPhysicalJob"
            />
            <label class="form-check-label" for="vallalkozas_igen">
              Igen
            </label>
          </div>
          <small id="fizikai-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Az ingatlan tulajdonjoga: <span class="text-danger">*</span>
          <button
            type="button"
            class="info border border-white"
            id="tulajdonjog-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_sajat"
              :value="'sajat'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_sajat">
              Saját tulajdon saját használatban
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_berbe"
              :value="'sajat_berbe'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_berbe">
              Saját tulajdon bérbe adva
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_berlemeny"
              :value="'berlemeny'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_berlemeny">
              Bérlemény
            </label>
          </div>
          <small id="tulajdonjog-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ingatlan_iranyito"
          >Az ingatlan irányítószáma: <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <div class="col-md-8 mb-2 dark-border">
            <!-- <Select2
              id="ingatlan_iranyito"
              name="iranyitoszam"
              v-model="propertyZip"
              :options="zipCodes"
              :settings="{selectionCssClass: 'w-full'}"
            /> -->
            <ValidationProvider rules="required|zipcode" v-slot="{errors}">
              <input
                type="text"
                id="ingatlan_iranyito"
                name="iranyitoszam"
                v-model="propertyZip"
                v-show="true"
                class="form-control dark-border"
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="telepules"
          >Település: <span class="text-danger">*</span></label
        >
        <div class="col-md-8 mb-2">
          <div class="col-md-4 mb-2 dark-border">
            <div v-if="cityNames.length > 1">
              <!-- <v-select 
                id="telepules"
                name="telepules"
                v-model="selectedPropertyName"
                :options="cityNames"
                :clearable="false"
                class="dark-border"
              /> -->
              <select
                id="telepules"
                name="telepules"
                v-model="selectedPropertyName"
                class="form-select dark-border"
              >
                <option v-for="(city, key) in cityNames" :key="key" :value="city">{{
                  city
                }}</option>
              </select>
            </div>
            <!-- <Select2
              id="telepules"
              name="telepules"
              v-model="selectedPropertyName"
              :options="cityNames"
              :settings="{selectionCssClass: 'w-full'}"
              v-if="cityNames.length > 1"
            /> -->
            <input
              v-else
              id="telepules"
              type="text"
              class="form-control mb-2 dark-border"
              readonly
              name="telepules"
              :value="selectedPropertyName"
            />
            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="text" :value="selectedPropertyName" v-show="false" />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <!-- <div class="form-group row mb-3">
        <label class="col-sm-4" for="telepules"
          >Település: <span class="text-danger">*</span></label
        >
        <div class="col-md-8 mb-2">
          <div class="col-md-4 mb-2">
            <Select2
              id="telepules"
              name="telepules"
              v-model="selectedPropertyName"
              :options="cityNames"
              :settings="{selectionCssClass: 'w-full'}"
              v-if="cityNames.length > 1"
            />
            <input
              v-else
              id="telepules"
              type="text"
              class="form-control mb-2 dark-border"
              readonly
              name="telepules"
              :value="selectedPropertyName"
            />
          </div>
        </div>
      </div> -->
    </div>
    <h1 class="mt-5">Biztosítani Kívánt Főépület Adatai</h1>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="hasznos_terulet"
        >Mekkora az épület/ingatlan hasznos alapterülete? (m2) <span class="text-danger">*</span>
        <button
          type="button"
          class="info border border-white"
          id="foepulet_alapterulet-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        rules="required|min_value:1|max_value:9999"
        v-slot="{errors, classes}"
        class="col-sm-8"
      >
        <div class="input-group">
          <input
            class="form-control dark-border"
            type="number"
            min="1"
            max="9999"
            name="alapterulet"
            id="hasznos_terulet"
            v-model="floorArea"
            :class="classes"
            aria-describedby="hasznos_terulet_m2"
          />
          <div class="input-group-append d-block dark-border">
            <span class="input-group-text" id="hasznos_terulet_m2">m2</span>
          </div>
        </div>
        <small id="foepulet_alapterulet-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="epulet_epites_ev"
        >Az ingatlan építési éve: <span class="text-danger">*</span>
        <button
          type="button"
          class="info border border-white"
          id="foepulet_epites_ev-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        :rules="{required: true, min_value: 1900, max_value: new Date().getYear() + 1900}"
        v-slot="{errors, classes}"
        class="col-sm-8"
      >
        <input
          class="form-control dark-border"
          type="number"
          min="1900"
          :max="new Date().getYear() + 1900"
          id="epulet_epites_ev"
          name="epites_eve"
          :class="classes"
          v-model="builtYear"
        />
        <small id="epites_eve-error" class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="ingatlan_lakok"
        >Hány lakó tartózkodik életvitelszerűen a biztosítani kívánt ingatlanban?
        <span class="text-danger">*</span>
        <button
          type="button"
          class="info border border-white"
          id="foepulet_lakok-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        rules="required|min_value:0|max_value:50"
        v-slot="{errors, classes}"
        class="col-sm-8"
      >
        <div class="input-group">
          <input
            class="form-control dark-border"
            type="number"
            :min="0"
            :max="50"
            id="ingatlan_lakok"
            name="lakok_szama"
            v-model="residents"
            :class="classes"
            aria-describedby="ingatlan_lakok_fo"
          />
          <div class="input-group-append d-block dark-border">
            <span class="input-group-text " id="ingatlan_lakok_fo">fő</span>
          </div>
        </div>
        <small id="lakok-error" class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="foepulet_falazat"
        >Milyen a biztosítani kívánt főépület falazata? <span class="text-danger">*</span>
        <button
          type="button"
          class="info border border-white"
          id="foepulet_falazat-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <select
          class="form-select dark-border"
          id="foepulet_falazat"
          name="foepulet_falazat"
          v-model="wallType"
          required
        >
          <option :value="'tegla'">Tégla</option>
          <option :value="'beton'">Beton</option>
          <option :value="'ko'">Kő</option>
          <option :value="'panel'">Panel</option>
          <option :value="'konnyuszerk'">Könnyűszerkezetes</option>
          <option :value="'fa'">Fa</option>
          <option :value="'valyog'">Vályog</option>
          <option :value="'vegyes'">Vegyes (vályog és szilárd)</option>
        </select>
        <span v-if="showPropertyWallWarning()"
          ><small class="text-warning fw-bold"
            >A megadott falazat típusra nem tudunk automatikusan biztosítási díjat számolni. Ebben
            az esetben biztosítási ajánlatát egyedi elbírálás alapján állítjuk ki.</small
          ></span
        >
        <small id="foepulet_falazat-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="foepulet_tetozet"
        >Milyen a biztosítani kívánt főépület tetőzete? <span class="text-danger">*</span>
        <button
          type="button"
          class="info border border-white"
          id="foepulet_tetozet-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <select
          class="form-select dark-border"
          id="foepulet_tetozet"
          name="foepulet_teto"
          v-model="roofType"
          required
        >
          <option :value="'cserep'">Cserép</option>
          <option :value="'pala'">Pala</option>
          <option :value="'nad'">Nád</option>
          <option :value="'fazsindely'">Fazsindely</option>
          <option :value="'szalma'">Szalma</option>
          <option :value="'bitumen'">Bitumenes</option>
          <option :value="'muanyag'">Műanyag</option>
          <option :value="'fem'">Fém</option>
          <option :value="'hullamlemez'">Bitumenes hullámlemez</option>
        </select>
        <span v-if="showPropertyRoofWarning()"
          ><small class="text-warning fw-bold"
            >A megadott tetőzet típusra nem tudunk automatikusan biztosítási díjat számolni. Ebben
            az esetben biztosítási ajánlatát egyedi elbírálás alapján állítjuk ki.</small
          ></span
        >
        <small id="foepulet_tetozet-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div v-if="contractFor !== 3">
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ajanlott_bizt"
          >A Biztosító által ajánlott biztosítási összeg:
          <button
            type="button"
            class="info border border-white"
            id="ajanlott_bizt_foepulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button>
          <div class="temp-warning fw-bold">
            Kérjük, ellenőrizze és szükség esetén módosítsa a biztosító által felkínált biztosítási
            összeget!
          </div></label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            id="ajanlott_bizt"
            :value="recommendedInsurancePrice | currency"
            readonly
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="valasztott_bizt"
          >Az Ön által választott biztosítási összeg:
          <button
            type="button"
            class="info border border-white"
            id="valasztott_bizt_foepulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider
          :rules="{required: true, currency_min: recommendedInsurancePrice}"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <div class="input-group">
            <input
              v-currency="{valueRange: {min: 0, max: 250000000}}"
              class="form-control dark-border"
              id="valasztott_bizt"
              name="ingatlan_erteke"
              :class="classes"
              aria-describedby="valasztott_ar_foepulet-prepend"
              v-model="chosenInsurancePrice"
              @click="clickedMainBuildingPrice = true"
              @focus="clickedMainBuildingPrice = true"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="valasztott_ar_foepulet-prepend">Ft</span>
            </div>
          </div>
          <small id="valasztott_ar_foepulet-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div>
      <h1 class="mt-5">Biztosítani Kívánt Melléképületek Adatai</h1>
      <div class="form-group row mb-5">
        <label class="col-sm-4" for="mellekepuletek"
          >Biztosítani kívánt melléképületek száma:
          <button
            type="button"
            class="info border border-white"
            id="biztositani_kivant_mellekepuletek-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-4 col-md-2 mb-4">
          <input
            class="form-control dark-border"
            type="number"
            readonly
            :value="sideBuildings.length"
            id="mellekepuletek"
          />
        </div>
        <div class="col-sm-4 col-md-2">
          <button type="button" class="btn btn-outline-danger w-100" @click="addSideBuilding">
            Hozzáadás
          </button>
        </div>
      </div>
      <div v-for="(building, key) in sideBuildings" :key="key">
        <h2 v-if="sideBuildings.length > 1" class="mt-5">{{ key + 1 }}. melléképület adatai</h2>
        <SideBuilding :building="building" :bKey="key" />
      </div>
      <div v-if="sideBuildings.length > 0 && contractFor !== 3">
        <hr class="mb-5" />
        <div class="form-group row mb-3">
          <label class="col-sm-4" :for="`mellek_ajanlott_bizt`"
            >A Biztosító által ajánlott biztosítási összeg:
            <button
              type="button"
              class="info border border-white"
              id="mellek_ajanlott_bizt-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
            >
              ?
            </button></label
          >
          <div class="col-sm-8">
            <input
              class="form-control dark-border"
              :id="`mellek_ajanlott_bizt`"
              :value="sideBuildingsRecommendedPrice | currency"
              readonly
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" :for="`valasztott_ar_mellekepulet`"
            >Az Ön által választott biztosítási összeg:
            <button
              type="button"
              class="info border border-white"
              id="valasztott_ar_mellekepulet-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
            >
              ?
            </button></label
          >
          <ValidationProvider
            :rules="{
              required: true,
              currency_min: sideBuildingsRecommendedPrice,
              currency_max: 20000000,
            }"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 20000000}}"
                class="form-control dark-border"
                :id="`valasztott_ar_mellekepulet`"
                :name="`valasztott_ar_mellekepulet`"
                :aria-describedby="`valasztott_ar_mellekepulet-prepend`"
                v-model="sideBuildingsChosenPrice"
                :class="classes"
                required
                @click="clickedSideBuildingPrice = true"
                @focus="clickedSideBuildingPrice = true"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" :id="`valasztott_ar_mellekepulet-prepend`">Ft</span>
              </div>
            </div>
            <small id="valasztott_ar_mellekepulet-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 2">
      <h1 class="mt-5">Biztosítani Kívánt Ingóságok Adatai</h1>
      <h2>Általános Ingóságok</h2>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ajanlott_ingosag_bizt"
          >Ajánlott ingóság biztosítási összeg:
          <button
            type="button"
            class="info border border-white"
            id="ajanlott_ingosag_bizt_osszeg-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button>
          <div class="temp-warning fw-bold">
            Kérjük, ellenőrizze és szükség esetén módosítsa a biztosító által felkínált biztosítási
            összeget!
          </div></label
        >
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control dark-border"
            id="ajanlott_ingosag_bizt"
            readonly
            :value="calculatedInsurancePrice | currency"
          />
        </div>
      </div>
      <div class="form-group row mb-3" v-if="calculatedInsurancePrice">
        <label class="col-sm-4">Elfogadja? <span class="text-danger">*</span></label>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ajanlott_bizt_osszeg_elfogad"
              id="ajanlott_bizt_osszeg_elfogad_igen"
              :value="1"
              v-model="acceptCalculatedInsurance"
            />
            <label class="form-check-label" for="ajanlott_bizt_osszeg_elfogad_igen">
              Elfogadom a felajánlott biztosítási összeget
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ajanlott_bizt_osszeg_elfogad"
              id="ajanlott_bizt_osszeg_elfogad_nem"
              :value="0"
              v-model="acceptCalculatedInsurance"
            />
            <label class="form-check-label" for="ajanlott_bizt_osszeg_elfogad_nem">
              Más összeget adok meg
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3" v-if="acceptCalculatedInsurance === 0">
        <label class="col-sm-4">Hogyan? <span class="text-danger">*</span></label>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="bizt_osszeg_fizetes"
              id="bizt_osszeg_fizetes_egyszerre"
              :value="'full'"
              v-model="priceType"
            />
            <label class="form-check-label" for="bizt_osszeg_fizetes_egyszerre">
              Egy összegben adom meg
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="bizt_osszeg_fizetes"
              id="bizt_osszeg_fizetes_reszlet"
              :value="'partial'"
              v-model="priceType"
            />
            <label class="form-check-label" for="bizt_osszeg_fizetes_reszlet">
              Részletezem
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3" v-if="priceType == 'full' && !acceptCalculatedInsurance">
        <label class="col-sm-4" for="ossz_ingosag"
          >Ingóságok összesen: <span class="text-danger">*</span></label
        >
        <ValidationProvider
          :rules="{required: true, currency_min: calculatedInsurancePrice, currency_max: 30000000}"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <div class="input-group">
            <input
              v-currency="{valueRange: {min: 0, max: 30000000}}"
              class="form-control dark-border"
              id="ossz_ingosag"
              name="ingosag_osszesen"
              aria-describedby="ingosagok_osszesen-prepend"
              :class="classes"
              v-model="allGoodsPrice"
              @input="clickedAllGoodsPrice = true"
              @click="clickedAllGoodsPrice = true"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="ingosagok_osszesen-prepend">Ft</span>
            </div>
          </div>
          <small id="ingosagok_osszesen-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div v-if="priceType == 'partial' && !acceptCalculatedInsurance">
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="haztartasi_gepek"
            >Háztartási gépek és eszközök, szerszámok, nem beépített lámpák</label
          >
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="haztartasi_gepek"
                name="haztartasigepek"
                aria-describedby="haztartasigep-prepend"
                :class="classes"
                v-model="householdPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="haztartasigep-prepend">Ft</span>
              </div>
            </div>
            <small id="haztartasigep-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="tele_eszkozok">Telekommunikációs eszközök</label>
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="tele_eszkozok"
                name="telekommunikacios_eszkozok"
                aria-describedby="kommunikacio-prepend"
                :class="classes"
                v-model="telecomPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="kommunikacio-prepend">Ft</span>
              </div>
            </div>
            <small id="kommunikacio-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="butorok">Bútorok</label>
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="butorok"
                name="butorok"
                aria-describedby="butorok-prepend"
                :class="classes"
                v-model="furniturePrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="butorok-prepend">Ft</span>
              </div>
            </div>
            <small id="butorok-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="ruha">Ruhanemű és lábbeli</label>
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="ruha"
                name="ruha_labbeli"
                aria-describedby="ruha-prepend"
                :class="classes"
                v-model="clothesPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="ruha-prepend">Ft</span>
              </div>
            </div>
            <small id="ruha-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="konyha_furdo_felsz"
            >Konyhai és fürdőszobai felszerelések</label
          >
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="konyha_furdo_felsz"
                name="konyhai_es_furdoszobai"
                aria-describedby="konyha-prepend"
                :class="classes"
                v-model="kitchenPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="konyha-prepend">Ft</span>
              </div>
            </div>
            <small id="konyha-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="textilek">Textilek</label>
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="textilek"
                name="textilek"
                aria-describedby="textilek-prepend"
                :class="classes"
                v-model="textilePrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="textilek-prepend">Ft</span>
              </div>
            </div>
            <small id="textilek-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="egyeb_targyak">Egyéb használható tárgyak</label>
          <ValidationProvider rules="currency_min:0" v-slot="{errors, classes}" class="col-sm-8">
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="egyeb_targyak"
                name="egyeb"
                aria-describedby="egyeb-prepend"
                :class="classes"
                v-model="otherPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="egyeb-prepend">Ft</span>
              </div>
            </div>
            <small id="egyeb-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="osszesito_mezo">Összesítő mező</label>
          <ValidationProvider
            :immediate="true"
            :rules="{
              required: true,
              currency_min: calculatedInsurancePrice,
              currency_max: 30000000,
            }"
            name="osszesito_mezo"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 30000000}}"
                class="form-control dark-border"
                id="osszesito_mezo"
                name="ingosag_osszesen"
                aria-describedby="osszesito_mezo-prepend"
                :class="classes"
                :value="summaryPrice"
                readonly
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="osszesito_mezo-prepend">Ft</span>
              </div>
            </div>
            <small id="osszesito_mezo-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <h2 class="mt-5">Értéktárgyak</h2>
      <div class="form-group row">
        <label class="col-sm-4" for="ertekek_200"
          >Értéktárgyak 200 000 Forint limitig
          <button
            type="button"
            class="info border border-white"
            id="ertekek_200-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <input
            readonly
            class="form-control mb-3 dark-border"
            id="ertekek_200"
            name="ertektargy200eig"
            :value="valuablesUnder200 | currency"
          />
          A Colonnade Minősített Fogyasztóbarát Otthonbiztosítás 200 000 Ft limit erejéig fedezetet
          nyújt értéktárgyakra. Ha ennél nagyobb összegű értéktárgyakat kíván biztosítani a
          "Kiegészítők" között erre lehetősége nyílik a következő oldalon.
        </div>
      </div>
    </div>
    <div v-if="sideBuildings.length > 0 && contractFor !== 2">
      <h2 class="mt-5">Melléképületek Ingóságai</h2>
      <div class="form-group row">
        <label class="col-sm-4" for="mellek_ingosag_becsult"
          >Melléképület ingóságainak becsült értéke
          <button
            type="button"
            class="info border border-white"
            id="mellek_ingosag-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider rules="min:0|max:30000000" v-slot="{errors, classes}" class="col-sm-8">
          <div class="input-group">
            <input
              type="number"
              min="0"
              max="30000000"
              class="form-control dark-border"
              id="mellek_ingosag_becsult"
              :class="classes"
              name="mellekepulet_ingosag"
              aria-describedby="mellekepulet_ingosag-prepend"
              v-model="sideBuildingsGoodsPrice"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="mellekepulet_ingosag-prepend">Ft</span>
            </div>
          </div>
          <small id="mellekepulet_ingosag-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import SideBuilding from './components/SideBuilding';
import Select2 from 'v-select2-component';

export default {
  components: {
    SideBuilding,
    Select2,
  },
  data() {
    return {
      cityNames: [],
      summaryPrice: 0,
      clickedMainBuildingPrice: false,
      clickedSideBuildingPrice: false,
      clickedAllGoodsPrice: false,
    };
  },
  computed: {
    ...mapFields([
      'cities',

      'generalInfo.contractType',
      'generalInfo.contractFor',
      'generalInfo.propertyType',
      'generalInfo.propertyInhabitated',
      'generalInfo.propertyOutskirts',
      'generalInfo.propertyPhysicalJob',
      'generalInfo.propertyOwnRight',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',
      // Main Building Insurance
      'insuranceProperty.floorArea',
      'insuranceProperty.recommendedInsurancePrice',
      'insuranceProperty.chosenInsurancePrice',
      'insuranceProperty.builtYear',
      'insuranceProperty.residents',
      'insuranceProperty.wallType',
      'insuranceProperty.roofType',
      // Personal Goods
      'insurancePersonalGoods.calculatedInsurancePrice',
      'insurancePersonalGoods.acceptCalculatedInsurance',
      'insurancePersonalGoods.priceType',
      'insurancePersonalGoods.allGoodsPrice',
      'insurancePersonalGoods.summaryInputs',
      'insurancePersonalGoods.valuablesUnder200',
      'insurancePersonalGoods.sideBuildingsGoodsPrice',
      'MFOLoaded',
    ]),
    ...mapFields({
      sideBuildingsTemplate: 'insuranceSideBuildings.template',
      sideBuildings: 'insuranceSideBuildings.list',
      householdPrice: 'insurancePersonalGoods.summaryInputs.household',
      telecomPrice: 'insurancePersonalGoods.summaryInputs.telecom',
      furniturePrice: 'insurancePersonalGoods.summaryInputs.furniture',
      clothesPrice: 'insurancePersonalGoods.summaryInputs.clothes',
      kitchenPrice: 'insurancePersonalGoods.summaryInputs.kitchen',
      textilePrice: 'insurancePersonalGoods.summaryInputs.textile',
      otherPrice: 'insurancePersonalGoods.summaryInputs.other',

      sideBuildingsRecommendedPrice: 'insuranceSideBuildings.recommendedInsurancePrice',
      sideBuildingsChosenPrice: 'insuranceSideBuildings.chosenInsurancePrice',
    }),
    ...mapGetters({
      data: 'getAllState',
    }),
    propertyNameIsArray: function() {
      return (
        typeof this.propertyName === 'object' && this.propertyName && this.propertyName.length > 0
      );
    },
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
  },
  watch: {
    propertyType: function(type) {
      if (!this.MFOLoaded) return;

      if (type == 'lakas') {
        this.wallType = 'panel';
        this.roofType = 'bitumen';
      } else {
        this.wallType = 'tegla';
        this.roofType = 'cserep';
      }
    },
    propertyZip: function() {
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.propertyZip))
      )
        return (this.cityNames = []);

      const zipData = this.cities[this.propertyZip];

      if (!zipData) return (this.cityNames = []);

      this.cityNames =
        typeof zipData.telepules === 'string'
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.cityNames.length === 1) {
        this.selectedPropertyName = this.cityNames[0];
      }
    },
    summaryInputs: {
      deep: true,

      handler(data) {
        this.calculateSummaryPrice(data);
      },
    },
    chosenInsurancePrice: function(value) {
      if (!this.clickedMainBuildingPrice) return;

      this.$store.commit('setMainInsuranceChangedState', true);
    },
    sideBuildingsChosenPrice: function(value) {
      if (!this.clickedSideBuildingPrice) return;

      this.$store.commit('setSideInsuranceChangedState', true);
    },
    allGoodsPrice: function(value) {
      if (!this.clickedAllGoodsPrice) return;

      this.$store.commit('setAllGoodsPriceChangedState', true);
    },
  },
  methods: {
    showPropertyWallWarning() {
      return ['fa', 'valyog', 'vegyes', 'konnyuszerk'].includes(this.wallType);
    },
    showPropertyRoofWarning() {
      return ['fazsindely', 'nad', 'szalma', 'muanyag', 'hullamlemez'].includes(this.roofType);
    },
    calculateSummaryPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value == 'string') {
          const string = value.replace(/\s/g, '').replace('Ft', '');
          const parsedInt = parseFloat(string);
          if (parsedInt) price += parsedInt;
        }
      }
      this.summaryPrice = price;
    },
    addSideBuilding() {
      if (this.sideBuildings.length < 5)
        this.$store.commit('addSideBuilding', Object.assign({}, this.sideBuildingsTemplate));
    },
  },
  created() {
    this.calculateSummaryPrice(this.summaryInputs);
  },
};
</script>

<style lang="scss">
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
}
.select2-selection__arrow {
  height: 38px !important;
}
.temp-warning {
  color: red;
}
</style>
